// extracted by mini-css-extract-plugin
export default {"root":"EmptyData_root__3g6yJ","description":"EmptyData_description__12FRH"};